import { useRef } from 'react'
import { difference } from 'lodash-es'
import { arrayToMap } from '@ow/utils'

export const defaultMapConfig = {
  zoom: 15,
  zooms: [5, 18],
}

export const getBoundFilter = (bounds) => ({
  logicType: 'and',
  queries: [
    {
      slug: 'lnglat',
      value: {
        coordinates: [[bounds]],
        type: 'MultiPolygon',
      },
      queryType: ['geo'],
    },
  ],
})

export const getLegendFilter = (queries) => ({
  logicType: 'and',
  queries,
})

// 校验自定义筛选值是否覆盖了视图中配置的图例筛选
export const isSkipLegend = (legendQueries, filterQueries) => {
  if (!legendQueries || !filterQueries) return false

  const filterMap = arrayToMap(filterQueries, 'slug')

  return legendQueries.some((legendQuery) => {
    const filterQuery = filterMap[legendQuery.slug]
    if (!filterQuery) return false

    if (filterQuery.queryType === 'isNull') return true

    if (filterQuery.queryType === 'notNull') return false

    if (Array.isArray(legendQuery.value)) {
      return Array.isArray(filterQuery.value)
        ? difference(filterQuery.value, legendQuery.value).length > 0
        : !legendQuery.value.includes(filterQuery.value)
    }

    return legendQuery.value !== filterQuery.value
  })
}

export const getGeoFieldSlug = (geoFieldSlug) => {
  if (typeof geoFieldSlug === 'string') return [geoFieldSlug]

  if (Array.isArray(geoFieldSlug)) return geoFieldSlug

  return 'lnglat'
}

// 分页获取数据并执行回调
export const usePageDataLoader = () => {
  const cache = useRef({})
  return (key) => async (ditto, params, cb) => {
    const timer = new Date().valueOf()
    cache.current[key] = timer
    const res = await ditto.fetchTbDataRaw(params)
    const { tbData, totalPages } = res
    cb(tbData)
    for (let pageNum = 1; pageNum < totalPages; pageNum++) {
      // eslint-disable-next-line no-await-in-loop
      const { tbData: data } = await ditto.fetchTbDataRaw({
        ...params,
        pageNum,
      })
      if (timer !== cache.current[key]) return
      cb(data)
    }
  }
}

// set layers by magConfig
export const getLayers = (mapConfig) => (AMap) =>
  mapConfig?.layers?.map((layer) => new AMap.TileLayer[layer]()) || []
